module.exports = __webpack_public_path__ + "static/media/Horse.ebf4afeb.glb";